import { render } from "./Card.vue?vue&type=template&id=21c1f58c&scoped=true"
const script = {}

import "./Card.vue?vue&type=style&index=0&id=21c1f58c&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21c1f58c"]])

export default __exports__